/**
 * Предустановленные причины отмены сессии: в sessions.canceled_note пишется ровно этот текст.
 * Общий контракт клиента (диалог отмены) и сервера (метрика отмен). «Не указана» — пустая строка, «Другая причина» — свободный текст.
 */
export const CANCEL_REASON_PRESET_NOTES = {
  extra: 'Лишняя сессия',
  reader_request: 'Отменена по просьбе чтеца',
  studio_initiative: 'Отменена по инициативе студии',
  no_show: 'Неявка чтеца',
  booking_error: 'Сессия забронирована по ошибке',
} as const;

export type CancelReasonPresetId = keyof typeof CANCEL_REASON_PRESET_NOTES;
